import axios from 'axios';
import { router } from '@/router';
import ajax from '@/resources/myApi';

export const userService = {
  logIn,
  logOut,
  changePassword,
  saveSettings,
  loadSettings,
  verifyCurrentPassword,
};

function logIn(username, password) {
  clearStorage();
  return axios
    .post(`${process.env.VUE_APP_API_URL}api/auth/login`, {

      username: username,
      password: password

    })
    .then(result => {
      if (result.data.token) {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        sessionStorage.setItem('user', result.data.token);
      }

      return result;
    });
}

function clearStorage() {
  localStorage.clear();
  sessionStorage.clear();
}

function logOut() {
  clearStorage();
  router.push('/login');
}

function changePassword(id, currentPassword, newPassword, confirmPassword) {
  var body = {
    id,
    currentPassword,
    newPassword,
    confirmPassword
  };
  return ajax
    .post('api/user/changepassword', {
      name: 'password',
      body
    })
    .then(result => result);
}

async function saveSettings({ id, settings }) {
  const data = await ajax.put(`api/user/SaveUserSettings/${id}`, {
    name: 'user settings',
    body: settings,
  });

  return data;
}

async function loadSettings(userId) {
  try {
    const { data } = await ajax.get(`api/user/UserSettings/${userId}`, {
      name: 'user settings',
    });

    return data;
  } catch (error) {
    return {};
  }
}

async function verifyCurrentPassword(id, currentPassword) {
  try {
    var body = {
      id,
      currentPassword,
    };
    return ajax
      .post('api/user/verifycurrentpassword', {
        name: 'password',
        body
      })
      .then(result => result);
  } catch (error) {
    return {};
  }
}